import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Image from 'next/image';
import { useSelector } from 'react-redux';
import AddNewFamilyMemberSidebarView from '@asterCore/Profile/AddNewFamilyMember/AddNewFamilyMemberSidebarView';
import ExistingFamilyMemberSidebar from '@asterCore/Profile/AddNewFamilyMember/ExistingFamilyMemberSidebar';
import { IC_ADD_FAMILY_MEMBER, IC_ADD_FEMALE_MEMBER, IC_CALL, IC_CONTACT, IC_UNDER_REVIEW } from '../../Assets/images';
import { MY_ASTER_CATEGORY } from '@common/Constants/analytics';
import { dataLayerSendEvent, sendPageViewEvent } from '@common/Utility/analytics-utils';
import { SPECIALITY_NAMES } from '@common/Utility/common-utils';
import { ONE_ASTER_CATEGORY } from '@common/Utility/constants';
import CommonSpaceHolder from '../CommonSpaceHolder/CommonSpaceHolder';
import Loader from '../Loader/Loader';
import RightSideBar from '../RightSideBar/RightSideBar';
import ProfilesList from './ProfilesList';
import UserDetail from '../UserDetail/UserDetail';
import { convertStartDate } from '@common/Utility/date-utils';
import ContactFormSidebar from '../Footer/ContactFormSidebar';

const SwitchProfileSideBar = ({
  patientProfileData,
  setShowProfilesList,
  setCheckSlotAvailabilityFlag,
  setSelectedProfileData,
  setAppointmentAlreadyBooked,
  setAlreadyBookedAppointmentId,
  setConsultationRestrictionMessage,
  patientId,
  setIsReferral,
  checkIcon,
  setSelectedSlot,
  getPatientDetails,
  setPayType,
  setIsCoverageCalled,
  setIsDefaultInsuranceCovered,
  invokeSessionStorage,
  getAllProfileData,
  setAddNewUserData,
  isEmptyProfile,
  specialisation,
  setIsMemberAdded,
  showOnlyExistingProfile,
  docName,
  isAddNewFamilyMemberHidden,
  enableUnderReviewSidebar,
  screenName,
  pageType,
  doctorId,
  referrerPage
}) => {
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const loading = useSelector((state) => state?.astercore?.checkUserExist?.isFetching);
  const loadingCompleteProfile = useSelector((state) => state?.astercore?.completeProfileApi?.isFetching);
  const loadingSendOtp = useSelector((state) => state?.astercore?.sendOtp?.isFetching);
  const loadingVerifyOtp = useSelector((state) => state?.astercore?.verifyOtp?.isFetching);
  const familyMembers = useSelector((state) => state?.astercore?.familyMember?.data?.body);
  const familyMemberLoading = useSelector((state) => state?.astercore?.familyMember?.isFetching);
  const appConfig = useSelector((state) => state?.astercore?.AppConfig?.data?.data);

  const [noSelectedUser, setNoSelectedUser] = useState(false);
  const [showAddMemberView, setShowAddMemberView] = useState(false);
  const [showExistingProfileView, setShowExistingProfileView] = useState(showOnlyExistingProfile || false);
  const [primaryButtonClicked, setPrimaryButtonClicked] = useState(0);
  const [notRelatedClicked, setNotRelatedClicked] = useState(0);
  const [showContactSideBar, setShowContactSideBar] = useState(false);
  const [disablePrimaryButtonFromSidebar, setDisablePrimaryButtonFromSidebar] = useState(false);

  useEffect(() => {
    if (showAddMemberView) {
      sendPageViewEvent('add_new_member_page', ONE_ASTER_CATEGORY.CORE, 'Add New Member Page', userLogin);
    }
  }, []);

  const handleClick = () => {
    setShowContactSideBar(true);
  };

  const getFamilyMemberText = (type) => {
    if (type === 'TITLE') {
      if (specialisation === SPECIALITY_NAMES?.GENERAL_MEDICINE || specialisation === SPECIALITY_NAMES?.INTERNAL_MEDICINE) {
        return 'Add Family Member (Age Above 13)';
      }
      if (specialisation === SPECIALITY_NAMES?.PEDIATRICS) {
        return 'Add Child’s Profile (Age Below 18)';
      }
      if (specialisation === SPECIALITY_NAMES?.OBS_AND_GYNEC) {
        return 'Add Only Female Family Member';
      }
      return 'Add Family Member';
    }
    if (type === 'SUBTITLE') {
      if (specialisation === SPECIALITY_NAMES?.PEDIATRICS) {
        return 'Book doctor appointments and manage health records for your child.';
      }
      if (specialisation === SPECIALITY_NAMES?.OBS_AND_GYNEC) {
        return 'Book doctor appointments and manage health records for your female family members.';
      }
      return 'Create user profile for your family members.';
    }

    return '';
  };

  const getModalTitle = () => {
    if (showAddMemberView) return 'Add Family Member';
    if (showExistingProfileView) {
      if (showOnlyExistingProfile) return 'Profile Found';
      return ' ';
    }
    return 'Switch Profile';
  };

  const getCustomClass = () => {
    if (showAddMemberView)
      return 'defaultInsuranceModal faq-contact-wrapper with-btn add_insurance_modal addFamilyModal';
    if (showExistingProfileView) return 'selectExistingProfileModal';
    if(patientProfileData?.[0]?.status === 'under review' && enableUnderReviewSidebar){
      return 'underReviewWrapper';
    }
    return isEmptyProfile
      ? 'upload_documents_modal faq-contact-wrapper with-btn'
      : 'selectProfileModal faq-contact-wrapper';
  };

  const isFooterEnabled = () => {
    if (showAddMemberView) return true;
    if (showExistingProfileView) return true;
    if(patientProfileData?.[0]?.status === 'under review' && enableUnderReviewSidebar){
      return false;
    }
    return isEmptyProfile || false;
  };

  const primaryButtonText = () => {
    if (showAddMemberView) return 'Continue Booking';
    if (showExistingProfileView) return 'Proceed';
    if(patientProfileData?.[0]?.status === 'under review' && enableUnderReviewSidebar) return null;
    return isEmptyProfile ? 'Add Family Member' : '';
  };

  const isFooterBtnFullWidth = () => {
    if (showAddMemberView) return true;
    if (showExistingProfileView) return true;
    return isEmptyProfile;
  };

  const handlePrimaryButtonClicked = () => {
    if (showAddMemberView) {
      setPrimaryButtonClicked((prev) => prev + 1);
      return;
    }

    if (showExistingProfileView) {
      setPrimaryButtonClicked((prev) => prev + 1);
      return;
    }

    if (isEmptyProfile) {
      if (familyMembers?.length) {
        setShowExistingProfileView(true);
      } else {
        setShowAddMemberView(true);
      }
    }
  };

 const getUserDisplayData = (data, isAdd = false) => {
   const name = `${data?.name}`;
   const isPrimary = data?.primaryAcc;
   return {
     image: data?.profilePic,
     nameInitial: data?.nameInitial,
     title: name,
     isPrimary,
     subtitle: {
       text1: isPrimary && !isAdd ? 'Primary Account' : data?.gender,
       text2: convertStartDate(data?.birthDate),
     },
     verification_status: data?.status,
     id: data?.id,
   };
 };

  const handleClose = () => {
    setShowProfilesList(false);
    setShowAddMemberView(false);
    setShowExistingProfileView(false);
    if (showAddMemberView && setCheckSlotAvailabilityFlag) {
      setCheckSlotAvailabilityFlag(false);
    }
  };

  const renderSidebarContent = () => {
    if (showAddMemberView) {
      return (
        <AddNewFamilyMemberSidebarView
          docName={docName}
          userData={userLogin}
          primaryButtonClicked={primaryButtonClicked}
          getAllProfileData={getAllProfileData}
          setAddNewUserData={setAddNewUserData}
          setShowAddMemberRightSideBar={setShowAddMemberView}
          setCheckSlotAvailability={setCheckSlotAvailabilityFlag}
          setSuccess={setIsMemberAdded}
          setDisablePrimaryButtonFromSidebar={setDisablePrimaryButtonFromSidebar}
        />
      );
    }

    if (showExistingProfileView) {
      return (
        <ExistingFamilyMemberSidebar
          docName={docName}
          noSelectedUser={noSelectedUser}
          primaryButtonClicked={primaryButtonClicked}
          setNoSelectedUser={setNoSelectedUser}
          familyMembers={familyMembers}
          setCheckSlotAvailability={setCheckSlotAvailabilityFlag}
          setShowExistingProfileView={setShowExistingProfileView}
          setShowAddMemberView={setShowAddMemberView}
          notRelatedClicked={notRelatedClicked}
          userId={userLogin?.id}
          setPrimaryButtonClicked={setPrimaryButtonClicked}
          setNotRelatedClicked={setNotRelatedClicked}
          getAllProfileData={getAllProfileData}
          handleClose={handleClose}
          setSuccess={setIsMemberAdded}
          setAddNewUserData={setAddNewUserData}
          showOnlyCheckBox={showOnlyExistingProfile}
          screenName={screenName}
          pageType={pageType}
          doctorId={doctorId}
          referrerPage={referrerPage}
        />
      );
    }

    return !isEmptyProfile ? (
      <ProfilesList
        docName={docName}
        patientProfileData={patientProfileData}
        setShowProfilesList={setShowProfilesList}
        setCheckSlotAvailabilityFlag={setCheckSlotAvailabilityFlag}
        setSelectedProfileData={setSelectedProfileData}
        setAppointmentAlreadyBooked={setAppointmentAlreadyBooked}
        setAlreadyBookedAppointmentId={setAlreadyBookedAppointmentId}
        setConsultationRestrictionMessage={setConsultationRestrictionMessage}
        patientId={patientId}
        setIsReferral={setIsReferral}
        checkIcon={checkIcon}
        setSelectedSlot={setSelectedSlot}
        getPatientDetails={getPatientDetails}
        setPayType={setPayType}
        setIsCoverageCalled={setIsCoverageCalled}
        setIsDefaultInsuranceCovered={setIsDefaultInsuranceCovered}
        invokeSessionStorage={invokeSessionStorage}
        setShowAddMemberView={setShowAddMemberView}
        setShowExistingProfileView={setShowExistingProfileView}
        areThereExistingProfiles={familyMembers?.length}
        isAddNewFamilyMemberHidden={isAddNewFamilyMemberHidden}
        screenName={screenName}
        pageType={pageType}
        doctorId={doctorId}
        referrerPage={referrerPage}
      />
    ) : patientProfileData?.[0]?.status === 'under review' && enableUnderReviewSidebar ? (
      <div className="under-review-profile">
        <UserDetail
          primaryUser={getUserDisplayData(patientProfileData?.[0])}
          percentage={patientProfileData?.percentage}
          customClass="userDetails"
        />
        <CommonSpaceHolder
          icon={IC_UNDER_REVIEW}
          title="Your profile is still under review"
          subtitle="Once profile status is updated, you will be able to add family members. Please contact myAster support center for more details."
          outerCustomClass="card-space-holder"
        >
          <div className="btnContainer btn-primary">
            <div className=" call me-3 ">
              <Image src={IC_CALL.src} alt="" width={35} height={35} />
              <span className="grey-contact-text ms-1">
                {appConfig?.find((x) => x.name === 'support_number')?.value}
              </span>
            </div>
            <span
              data-test="id"
              className="call cursor-pointer"
              onClick={() => {
                handleClick();
              }}
            >
              <Image src={IC_CONTACT.src} alt="" width={35} height={35} />
              <span className="blue-contact-text ms-1">Contact us</span>{' '}
            </span>
          </div>
        </CommonSpaceHolder>
      </div>
    ) : (
      <div className="px-3 align-items-center d-flex h-100">
        <CommonSpaceHolder
          outerCustomClass="insurance-success-panel bgGrey"
          icon={specialisation === SPECIALITY_NAMES?.OBS_AND_GYNEC ? IC_ADD_FEMALE_MEMBER : IC_ADD_FAMILY_MEMBER}
          title={getFamilyMemberText('TITLE')}
          subtitle={getFamilyMemberText('SUBTITLE')}
        />
      </div>
    );
  };

  const renderNotRelatedButton = () => (
    <Button
      size="sm"
      style={{ margin: 0 }}
      onClick={() => {
        setNotRelatedClicked((prev) => prev + 1);
        dataLayerSendEvent('not_related_button_click', {
          screen_name: 'asco homepage',
          page_type: 'homepage',
          myaster_category: MY_ASTER_CATEGORY?.ASCO,
        });
      }}
      variant="link"
    >
      {showOnlyExistingProfile ? 'Not Related to me' : 'Not Related, Create New'}
    </Button>
  );

  return (
    <>
      <Loader
        isLoading={loading || loadingCompleteProfile || loadingSendOtp || loadingVerifyOtp || familyMemberLoading}
      />
      <RightSideBar
        modalTitle={getModalTitle()}
        size="md"
        closeButton
        customClass={getCustomClass()}
        footerEnable={isFooterEnabled()}
        primaryButtonText={primaryButtonText()}
        footerBtnFullWidth={isFooterBtnFullWidth()}
        primaryButtonClicked={handlePrimaryButtonClicked}
        isPrimaryButtonDisabled={disablePrimaryButtonFromSidebar}
        handleClose={handleClose}
        footerAlignment="center"
        bodyTextCenter={isEmptyProfile && !showAddMemberView && !showExistingProfileView}
        isBackEnabled={(showAddMemberView || showExistingProfileView) && !showOnlyExistingProfile}
        backButtonClicked={() => {
          if (showAddMemberView) {
            setShowAddMemberView(false);
            if (familyMembers?.length) {
              setShowExistingProfileView(true);
            }
          } else if (showExistingProfileView) {
            setShowExistingProfileView(false);
          }
        }}
        customFooter={showExistingProfileView ? renderNotRelatedButton() : null}
      >
        {renderSidebarContent()}
      </RightSideBar>
      {showContactSideBar && (
        <ContactFormSidebar
          wrapperClassName="contact cursor-pointer"
          showLabel={false}
          setShowContactSideBar={setShowContactSideBar}
        />
      )}
    </>
  );
};

SwitchProfileSideBar.propTypes = {
  patientProfileData: PropTypes.array.isRequired,
  setShowProfilesList: PropTypes.func.isRequired,
  setCheckSlotAvailabilityFlag: PropTypes.func,
  setSelectedProfileData: PropTypes.func,
  setAppointmentAlreadyBooked: PropTypes.func,
  setAlreadyBookedAppointmentId: PropTypes.func,
  setConsultationRestrictionMessage: PropTypes.func,
  patientId: PropTypes.string,
  setIsReferral: PropTypes.func,
  checkIcon: PropTypes.string,
  setSelectedSlot: PropTypes.func,
  getPatientDetails: PropTypes.func,
  setPayType: PropTypes.func,
  setIsCoverageCalled: PropTypes.func,
  setIsDefaultInsuranceCovered: PropTypes.func,
  invokeSessionStorage: PropTypes.func,
  getAllProfileData: PropTypes.func.isRequired,
  setAddNewUserData: PropTypes.func.isRequired,
  isEmptyProfile: PropTypes.bool.isRequired,
  specialisation: PropTypes.string.isRequired,
  setIsMemberAdded: PropTypes.func.isRequired,
  showOnlyExistingProfile: PropTypes.bool,
  docName: PropTypes.string.isRequired,
  isAddNewFamilyMemberHidden: PropTypes.bool,
  screenName: PropTypes.string,
  pageType: PropTypes.string,
};

SwitchProfileSideBar.defaultProps = {
  setCheckSlotAvailabilityFlag: () => {},
  setSelectedProfileData: () => {},
  setAppointmentAlreadyBooked: () => {},
  setAlreadyBookedAppointmentId: () => {},
  setConsultationRestrictionMessage: () => {},
  patientId: '',
  setIsReferral: () => {},
  checkIcon: '',
  setSelectedSlot: () => {},
  getPatientDetails: () => {},
  setPayType: () => {},
  setIsCoverageCalled: () => {},
  setIsDefaultInsuranceCovered: () => {},
  invokeSessionStorage: () => {},
  showOnlyExistingProfile: false,
  isAddNewFamilyMemberHidden: false,
  screenName: '',
  pageType: '',
};

export default SwitchProfileSideBar;
